export default "<app-login-form></app-login-form>\n"